import moment from "moment";

const formatFullDate = "dddd, MMMM Do YYYY";

/**
 * Historic usage: formats a full date (kept for compatibility).
 * @param {*} date
 */
export const formatTime = (date) => moment(date).format(formatFullDate);

/**
 * Relative time like "vor 5 Minuten".
 * @param {*} date
 */
export const getTimeFromNow = (date) => moment(date).fromNow();

/**
 * Chat bubble time: 24h clock, e.g. "14:07".
 * @param {*} date
 */
export const formatMessageTime = (date) => moment(date).format("HH:mm");

/**
 * Returns a stable key for grouping by calendar day.
 * @param {*} date
 */
export const getDayKey = (date) => moment(date).format("YYYY-MM-DD");

/**
 * Human-friendly day header for chats.
 * Heute | Gestern | dddd, DD. MMM | DD.MM.YYYY
 * @param {*} date
 */
export const formatDayHeader = (date) => {
  const m = moment(date);
  const today = moment();
  if (m.isSame(today, "day")) return "Heute";
  if (m.isSame(today.clone().subtract(1, "day"), "day")) return "Gestern";
  if (today.diff(m, "days") < 7) return m.format("dddd, DD. MMM");
  return m.format("DD.MM.YYYY");
};

/**
 * Full timestamp for tooltips/details, e.g. "DD.MM.YYYY, HH:mm".
 * @param {*} date
 */
export const formatMessageTimestamp = (date) =>
  `${moment(date).format("DD.MM.YYYY")}, ${moment(date).format("HH:mm")}`;
